<template>
<div class="chapter">
<div class="inner_page">
<h1 class="halftitle"><a id="page_iii"></a><i>Back in<br/>Charge!</i></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Halftitle.vue?33ce632c